module.exports = __webpack_public_path__ + "images/33b22c51b1b6c5aaa44812724e136080.svg";